import {Component, OnInit} from '@angular/core';
import {DashboardService} from './dashboard.service';
import {DashboardMenuModel, DashboardPDModel, ActionLog} from './../../models/dashboard/dashboard.model';
import {Router} from '@angular/router';
import {AuthTokenService} from '../../shared/services/auth-token.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent implements OnInit {

  filter: boolean;
  dashboardArray: Array<any>;
  column: string;
  isDesc: boolean;
  pageData: DashboardPDModel;
  logData: ActionLog;
  loader: boolean;

  // constructor() { }
  constructor(public router: Router, private dashboardService: DashboardService) {
  }

  ngOnInit() {

    this.filter = false;
    this.column = 'Title';
    this.isDesc = false;

    this.pageData = new DashboardPDModel();

    this.loader = true;
    this.dashboardService.getPageData().subscribe(
      (response) => {
        this.loader = false;
        this.pageData = response;
      },
      (error) => {
        // console.log(error);
      }
    );

    this.dashboardService.getActionLog().subscribe(
      (response) => {
        this.logData = response;

      },
      (error) => {
        // console.log(error);
      }
    );

  }

  calculateCellValue(data) {
    let date = new Date(data.dateCreated);
    return date.getHours() + ":" + date.getMinutes();
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/dashboard/dashboard.component.ts